import { Carousel } from 'antd';
import React from 'react';

function CollectionCarouselLoading({ settings }) {
  const videoData = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  return (
    <section className="collection-carousel skeleton-loader">
      <div className="container">
        <div className="section-header skeleton-loader">
          <div className="sh-top mb-4">
            <div className="sh-title skeleton" />
            <span className="flex-1" />
            <div className="d-flex align-center text-n-900 button-m skeleton" />
          </div>
        </div>
      </div>
      <div className="one-side-carousel">
        <div className="w-full video-carousel shadow-arrow">
          <Carousel {...settings}>
            {videoData.map((item) => (
              <div className="collection-card  skeleton-loader" key={item}>
                <div className="collection-img skeleton" />
                <div className="collection-dec">
                  <div className="category skeleton" />
                  <div className="part skeleton" />
                  <div className="paragraph skeleton" />
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
}

export default CollectionCarouselLoading;
